// Drops slider — ported from webflow-export/js/drops.js
// Requires Swiper v8 (loaded via snippets/swiper-scripts.liquid)

const initDropsSlider = () => {
  document.querySelectorAll('[data-drops-slider]').forEach(function (element) {
    let loopMode = false;
    if (element.getAttribute('loop-mode') === 'true') {
      loopMode = true;
    }
    let sliderDuration = 300;
    if (element.getAttribute('slider-duration') !== null) {
      sliderDuration = +element.getAttribute('slider-duration');
    }

    const swiperEl = element.querySelector('[data-drops-swiper]');
    if (!swiperEl) return;

    new Swiper(swiperEl, {
      speed: sliderDuration,
      loop: loopMode,
      autoHeight: false,
      centeredSlides: false,
      followFinger: true,
      freeMode: false,
      slidesPerView: 'auto',
      slideToClickedSlide: false,
      spaceBetween: 22,
      loopedSlides: 50,
      rewind: false,
      mousewheel: {
        forceToAxis: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    });
  });
};

// Init on DOMContentLoaded (Swiper is loaded at end of <body> so it's ready by now)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDropsSlider);
} else {
  initDropsSlider();
}
